import { useContext } from 'react';
import { css, forBrands, getFont, getFontWeight } from '@core-ui/react-stitch';
import { FeatureFlagsContext } from '@core-ui/feature-flags';
import { DefaultStyleFn } from '@src/types/buttonVariant';

export const getDefaultStyles: DefaultStyleFn = ({ theme, isXLarge }) => {
  const { enabledFeatures } = useContext(FeatureFlagsContext);
  const isBRColorChange = enabledFeatures['br-colors-2023'];

  const brandStyles = forBrands(theme, {
    gap: ({ color }) => css`
    ${getFont('primary')({ theme })}
    color: ${color.b2};
    font-size: 0.8rem;
    padding: 0;
  `,
    gapfs: ({ color }) => css`
    ${getFont('primary')({ theme })}
    color: ${color.b2};
    font-size: 0.8rem;
    padding: 0;
  `,
    on: ({ color }) => css`
    ${getFont('secondary')({ theme })}
    color: ${color.b1};
    font-size: 0.8rem;
    padding: 1px 0 0 0;
  `,
    br: ({ color }) => css`
    ${getFont('primary')({ theme })}
    ${getFontWeight('demiBold')};
    color: ${isBRColorChange ? color.b1 : color.g1};
    font-size: 12px;
    border: none;
    line-height: 14px;
    text-transform: capitalize;
    padding: 0;
    letter-spacing: 0.3px;
  `,
    brfs: ({ color }) => css`
    ${getFont('primary')({ theme })}
    ${getFontWeight('demiBold')};
    color: ${isBRColorChange ? color.b1 : color.g1};
    font-size: 12px;
    border: none;
    line-height: 14px;
    text-transform: capitalize;
    padding: 0;
    letter-spacing: 0.3px;
  `,
    at: ({ color }) => css`
    ${getFont('secondary')({ theme })}
    color: ${color.g1};
    letter-spacing: 1px;
    font-size: 0.8125rem;
    padding: 0.25rem 0;
    `,
  });

  return css`
    ${theme.utilities.unbuttonize}
    display: inline-block;
    letter-spacing: 0.0625em;
    padding: 3px;
    width: auto;
    cursor: pointer;
    text-transform: uppercase;
    ${brandStyles}
    ${!isXLarge && 'font-size: 1.2rem'};
  `;
};
